import {
	bodyFontFamily,
	breakpoints,
	Button,
	colors,
	Flex,
	Icon,
	NavigationPopup,
	scale,
} from "@capioweb/ui-components/src"
import React from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { AppContext, LocalesContext } from "../../../context"
import { AutoSuggest } from "../../SearchHeroBlock/components/AutoSuggest"
import { HeaderContext } from "../context/HeaderContext"

const InputStyled = styled.input`
	width: 100%;
	border: none;
	font-size: ${scale.px(2)};
	line-height: ${scale.px(3)};
	font-weight: 400;
	padding-top: ${scale.px(2)};
	padding-bottom: ${scale.px(2)};
	color: ${colors.primary};
	background-color: white;

	&:focus-visible {
		outline: none;
	}

	&::placeholder {
		font-size: 16px;
		font-family: ${bodyFontFamily};
	}
`

const InputWrapperStyled = styled.form`
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin-top: ${scale.px(2)};
	border: 1px solid ${colors.blue33};
	border-radius: 8px;
	background-color: white;
	z-index: 15;

	&:focus-within {
		outline: 2px solid ${colors.navy};
		border-radius: 8px;
	}
	@media screen and (max-width: ${breakpoints.l}px) {
		margin-bottom: ${scale.px(1)};
	}
`

interface SearchPopupStyledProps {
	isStickyHeader?: boolean
}
interface SearchPopupProps extends SearchPopupStyledProps {
	label: string
	showPopup: React.Dispatch<React.SetStateAction<boolean>>
}

const SearchPopup: React.FC<SearchPopupProps> = ({ label, showPopup }) => {
	const searchUrl = (query: string) => `/sok?query=${query}`
	const [input, setInput] = React.useState<string>("")
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const { isStickyHeader, setShowSearchPopup } = React.useContext(HeaderContext)
	const { getUserLocation } = React.useContext(AppContext)
	const navigate = useNavigate()
	const SearchSubmitBtn = (
		<Button
			as="a"
			type="button"
			href={searchUrl(input)}
			style={{ width: "100%" }}
		>
			{label}
		</Button>
	)
	return (
		<>
			<NavigationPopup
				size={isStickyHeader ? "small" : "normal"}
				heading={translate(translationKeys.search)}
				showPopup={setShowSearchPopup}
				isSearchPopup
				arrowOffset="32.5px"
			>
				<InputWrapperStyled
					onSubmit={(e) => {
						e.preventDefault()
						navigate(searchUrl(input), { replace: true })
						setShowSearchPopup(false)
					}}
				>
					<Flex flexDirection="column">
						<Icon icon="search" my="auto" ml={2} mr={1}></Icon>
					</Flex>
					<Flex width={1} pr={2} flexDirection="column">
						<Flex my="auto">
							<InputStyled
								type="search"
								placeholder={translate(translationKeys.searchPlaceholder)}
								onChange={(event) => setInput(event.target.value)}
								autoFocus
							></InputStyled>
						</Flex>
					</Flex>
					<Flex display={{ _: "none", m: "flex" }} my={1.5} mx={1}>
						{SearchSubmitBtn}
					</Flex>
				</InputWrapperStyled>
				<Flex display={{ _: "flex", m: "none" }} w={1}>
					{SearchSubmitBtn}
				</Flex>
				{input.length >= 3 && <AutoSuggest query={input} isSearchPopup />}
			</NavigationPopup>
			<Flex
				as="button"
				w="100vw"
				h="100vh"
				position="fixed"
				top="0"
				left="0"
				onClick={() => setShowSearchPopup(false)}
				zIndex={5}
				style={{ cursor: "auto" }}
				tabIndex={-1}
			></Flex>
		</>
	)
}

export { SearchPopup }
